<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
// Card "Avaliação do atendimento" do "Histórico de cliente".
// Extraído de HistoricoCliente.vue: mesma copy e mesmos dois estados.
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { formatDateTime } from '../utils/leadHistoryPresenter';

const props = defineProps({
  feedback: { type: Object, default: null },
  canEvaluate: { type: Boolean, default: false },
  unavailableMessage: { type: String, default: '' },
});

defineEmits(['open']);

const feedbackAlreadySubmitted = computed(() =>
  Boolean(props.feedback?.comment)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Avaliação do atendimento">
    <div v-if="feedbackAlreadySubmitted" class="grid gap-3">
      <div class="rounded-lais-sm border border-[#eee5d6] bg-[#fafafa] p-4">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <p class="text-[13px] font-semibold text-lais-text">Comentário</p>
          <span
            v-if="feedback.rating"
            class="rounded-full bg-[#f8f4fc] px-2 py-1 text-[11px] font-semibold text-lais-primary"
          >
            Nota {{ feedback.rating }}
          </span>
        </div>
        <p class="mt-2 text-[13px] leading-relaxed text-lais-text-body">
          {{ feedback.comment }}
        </p>
        <p
          v-if="feedback.submitted_at"
          class="mt-2 text-[11px] text-lais-text-muted"
        >
          Enviado em
          {{ formatDateTime(feedback.submitted_at) }}
        </p>
      </div>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-pencil"
        size="sm"
        :disabled="!canEvaluate"
        :title="unavailableMessage || undefined"
        @click="$emit('open')"
      >
        Atualizar avaliação
      </LaisPrimaryButton>
    </div>
    <div v-else class="grid gap-3">
      <p class="text-[13px] leading-relaxed text-lais-text-body">
        Deixe aqui sua opinião sobre esta conversa.
      </p>
      <LaisPrimaryButton
        icon="i-lucide-message-square-heart"
        size="sm"
        :disabled="!canEvaluate"
        :title="unavailableMessage || undefined"
        @click="$emit('open')"
      >
        Avaliar atendimento
      </LaisPrimaryButton>
    </div>
    <p
      v-if="!canEvaluate && unavailableMessage"
      class="mt-3 text-[12px] leading-relaxed text-lais-text-muted"
    >
      {{ unavailableMessage }}
    </p>
  </LaisCard>
</template>
